<template>
  <div>
    <div v-if="$store.state.accounts.length > 1">ЛС</div>
    <b-tabs content-class="mt-3">
      <b-tab title="Телефония" active>
        <b-table v-if="$store.getters.calls.length > 0" striped hover :items="$store.getters.calls" :fields="phone_fields"></b-table>
        <div v-else>Нет данных</div>
      </b-tab>
      <b-tab title="Интернет">
        <b-table striped hover v-if="$store.getters.traffic.length > 0" :items="$store.getters.traffic" :fields="internet_fields"></b-table>
        <div v-else>Нет данных</div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "StatisticView",
  created() {
    this.$store.dispatch('getPhoneCalls', {'account_id': this.$store.state.current_account})
    this.$store.dispatch('getInternetTraffic', {'account_id': this.$store.state.current_account})
  },
  data() {
    return {
      phone_fields: [
          {key: 'number', label: 'Номер'},
          {key: 'code_name', label: 'Направление'},
          {key: 'country', label: 'Страна'},
          {key: 'call_duration', label: 'Секунд'},
          {key: 'bdate', label: 'Начало'},
          {key: 'called', label: 'Набор'},
          {key: 'price', label: 'Цена'},
          {key: 'steps', label: 'Шаги'},
          {key: 'final_amount', label: 'Сумма'},
      ],
      internet_fields: [
          {key: 'service_name', label: 'Позиция'},
          {key: 'final_amount', label: 'Сумма'},
      ],
    }
  }
}
</script>

<style scoped>

</style>